import axios from "axios";
import {getHeader, getSpecialtiesLink, getSpecialtyDetailsLink} from "./../../config";
import {types} from "../types/globalTypes";
import {specialtyTypes} from "../types/specialtyTypes";

export const getSpecialtiesList = (featured = 0) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.post(getSpecialtiesLink, { featured: featured }, { headers: getHeader() }).then(res => {
            if (res.data.status !== true) {
                const specialties = res.data.Response;
                if (featured === 0) {
                    dispatch({
                        type: specialtyTypes.GET_All_SPECIALITIES_LIST,
                        payload: specialties
                    })
                } else {
                    dispatch({
                        type: specialtyTypes.GET_SPECIALITIES_LIST,
                        payload: specialties
                    });
                }
            }
        }).catch(error => {
            console.log(error)
            // dispatch({
            //     type: "ERROR_500",
            //     payload: error,
            // })
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        });

    }
};


export const getSpecialtyDetails = (slug) => {
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.post(getSpecialtyDetailsLink, { slug: slug}, { headers: getHeader() }).then(res => {
            if (res.data.Error.status === true){
                const currentSpecialty = res.data.Response;
                dispatch({
                    type: specialtyTypes.GET_SPECIALTY_DETAILS,
                    payload: currentSpecialty
                });
                console.log(currentSpecialty);
            } else {
                dispatch({
                    type: specialtyTypes.CURRENT_SPECIALTY_NOT_FOUND,
                    payload: true
                });
            }
        }).catch(err => {
            console.log("err", err);
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });

        })
    }
};



export const clearSpecialtyList = () => {
    return (dispatch, getState) => {
        dispatch({
            type: specialtyTypes.CLEAR_SPECIALTY_LIST,
            payload: []
        });


    }
};



export const clearSpecialtyDetails = () => {
    return (dispatch, getState) => {
        dispatch({
            type: specialtyTypes.CLEAR_SPECIALTY_DETAILS,
            payload: null
        });


    }
};



